// Module
var code = "<li class=\"search-nav\"> <div class=\"tunnel-line\" id=\"1\"> <div class=\"tunnel-line-text\"><span class=\"description\"></span></div> </div> </li>";
// Exports
module.exports = code;